import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SampleSelectionRepository } from '@service/sample-selection/sample-selection.repository';
import { SampleSelection } from '@model/sample-selection/sample-selection.model';
import { SampleSelectionQueryParams } from '@model/sample-selection/sample-selection-query-params.model';
import { PaginatedResponse } from '@model/common/pagination.model';

/**
 * Use case for getting samples for selection
 * HU32-922499: Selección de muestras para procesamiento
 */
export class GetSamplesUseCase {
  private readonly repository = inject(SampleSelectionRepository);

  execute(
    params?: SampleSelectionQueryParams
  ): Observable<PaginatedResponse<SampleSelection>> {
    return this.repository.findAll(params);
  }
}
